/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/label-has-associated-control */

import React, { useState, useEffect, useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Button, FormGroup } from 'reactstrap';
import Storage from '../../utils/storega';
import { HomePageLayout } from '../CRs_T12_2022_HomePage/index';
import { methodApiNoAuth } from '../CRs_T12_2022_HomePage/apis/noAuth';
import { SelectPeriod } from '../CRs_T12_2022_HomePage/components/SelectPeriod';
import { IntroPage } from '../CRs_T12_2022_HomePage/pages/IntroPage';
import { SelectSchoolBuilding } from '../sign-in/SelectSchoolBuilding';
import { teacherLoginGaihan, getTeacherBuildings } from '../../store/actions/teacherAuth';
import { SelectMode } from '../sign-in/signInModeSelectLesson';
import { pushNotify } from '../../components/notifycation';
import { GaihanWrapper, GaihanFormContent } from './style';

const SignInGaihan = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  // Clear localStorage if coming from NAI_BU (systemCode=1)
  if (Storage.get('SYSTEM_CODE') === '1' || Storage.get('SYSTEM_CODE') === 1) {
    window.localStorage.clear();
  }

  // If teacher is already authenticated, go directly to Step 2
  const initialStep = Storage.has('TEACHER_ACCESS_TOKEN') ? 2 : 1;

  const [step, setStep] = useState(initialStep);
  const [loading, setLoading] = useState(false);

  // Step 1 state
  const [schoolId, setSchoolId] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  // Step 2 state
  const [optSchoolBuilding, setOptSchoolBuilding] = useState([]);
  const [schoolBuildingValue, setSchoolBuildingValue] = useState('');
  const [periodList, setPeriodList] = useState([]);
  const [periodCode, setPeriodCode] = useState('');
  const [isMode, setIsMode] = useState('input');
  const [isConfirm, setIsConfirm] = useState(false);

  // Teacher info display
  const teacherInfo = Storage.get('TEACHER_INFO');
  const teacherDisplayName = teacherInfo?.userName || teacherInfo?.userId || '';

  // Logout handler
  const handleLogout = useCallback(() => {
    Storage.remove('TEACHER_ACCESS_TOKEN');
    Storage.remove('TEACHER_INFO');
    Storage.remove('SCHOOL_ID');
    Storage.remove('SCHOOL_BUILDING_ID');
    Storage.remove('PERIOD_ID');
    Storage.remove('LIST_PERIOD');
    Storage.remove('SCHOOL_BUILDING_LIST');
    Storage.remove('SYSTEM_CODE');
    Storage.remove('USER_ACCESS_TOKEN');
    Storage.remove('MAIN_MODE');
    Storage.remove('OLD_MAIN_MODE');
    setStep(1);
    setSchoolId('');
    setUsername('');
    setPassword('');
    setOptSchoolBuilding([]);
    setSchoolBuildingValue('');
    setPeriodList([]);
    setPeriodCode('');
    // Clear step param from URL
    history.replace('/sign-in-gaihan');
  }, [history]);

  // Load school buildings filtered by teacherId
  const callGetListSchoolBuilding = useCallback((sid) => {
    dispatch(getTeacherBuildings({
      schoolId: sid || schoolId,
      onSuccess: (buildings) => {
        setOptSchoolBuilding(buildings);
      },
      onError: (err) => {
        // Handle token expired — redirect to Step 1
        if (err?.status === 401 || err?.message === 'Unauthorized') {
          handleLogout();
          pushNotify('error', 'セッションの有効期限が切れました。再度ログインしてください。');
        }
      }
    }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolId, handleLogout]);

  // Load saved state when returning to Step 2
  useEffect(() => {
    if (step === 2) {
      // Check token still valid before loading Step 2
      if (!Storage.has('TEACHER_ACCESS_TOKEN')) {
        setStep(1);
        pushNotify('error', 'セッションの有効期限が切れました。再度ログインしてください。');
        return;
      }
      const savedSchoolId = Storage.get('SCHOOL_ID');
      if (savedSchoolId) {
        setSchoolId(savedSchoolId);
      }
      const cachedBuildings = Storage.get('SCHOOL_BUILDING_LIST');
      if (cachedBuildings && cachedBuildings.length > 0) {
        setOptSchoolBuilding(cachedBuildings);
      }
      if (Storage.get('SCHOOL_BUILDING_ID')) {
        setSchoolBuildingValue(Storage.get('SCHOOL_BUILDING_ID'));
      }
      if (Storage.get('LIST_PERIOD')) {
        setPeriodList(Storage.get('LIST_PERIOD'));
      }
      if (Storage.get('PERIOD_ID')) {
        setPeriodCode(Storage.get('PERIOD_ID'));
      }
      // Always call API if no valid cached buildings
      if ((!cachedBuildings || cachedBuildings.length === 0) && savedSchoolId) {
        callGetListSchoolBuilding(savedSchoolId);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  // Step 1: Login handler
  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);

    const trimmedSchoolId = schoolId.trim();
    const trimmedUsername = username.trim();
    setSchoolId(trimmedSchoolId);
    setUsername(trimmedUsername);

    dispatch(teacherLoginGaihan({
      schoolId: trimmedSchoolId,
      username: trimmedUsername,
      password,
      onSuccess: () => {
        setStep(2);
        callGetListSchoolBuilding(schoolId);
        setLoading(false);
      },
      onError: () => {
        setLoading(false);
      }
    }));
  };

  // Load timetables when school building changes
  useEffect(() => {
    if (step === 2 && schoolId && schoolBuildingValue && !Storage.has('MAIN_MODE')) {
      setPeriodList(null);
      setLoading(true);
      dispatch(methodApiNoAuth.getListTimeTables({
        params: { systemCode: 2, schoolId, schoolBuildingId: schoolBuildingValue },
        success: (res) => {
          setPeriodList(res?.data?.content);
          setPeriodCode(res?.data?.content?.[0]?.periodCode);
        },
        final: () => setLoading(false)
      }));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolBuildingValue]);

  // Step 2: Register handler
  const handleRegister = (e) => {
    e.preventDefault();
    Storage.set('SCHOOL_BUILDING_ID', schoolBuildingValue);
    Storage.set('PERIOD_ID', periodCode);
    Storage.set('LIST_PERIOD', periodList);
    Storage.set('SCHOOL_BUILDING_LIST', optSchoolBuilding);
    Storage.set('SYSTEM_CODE', '2');

    setIsConfirm(true);
    setLoading(true);
    dispatch(methodApiNoAuth.getListUserProfile({
      params: {
        systemCode: 2,
        schoolCode: schoolId,
        schoolBuildingCode: schoolBuildingValue,
        periodCode
      },
      success: () => {
        Storage.set('MAIN_MODE', isMode);
        Storage.set('OLD_MAIN_MODE', isMode);
      },
      final: () => setLoading(false)
    }));
  };

  // Back from IntroPage → reset to Step 2
  const resetMainMode = (event) => {
    event.preventDefault();
    Storage.remove('MAIN_MODE');
    window.location.reload();
    return true;
  };

  // Render login form (Step 1)
  const renderLoginForm = () => (
    <GaihanFormContent style={{ height: 'auto', marginTop: 0, position: 'relative' }}>
      <p><span style={{ color: '#E37713' }}><b>AI 学トレ</b></span></p>
      <h2 className="mb-3">加盟校ログイン</h2>
      <form onSubmit={handleLogin}>
        <FormGroup className="form-group">
          <label className="form-label">塾コード</label>
          <input
            type="text"
            className="form-control"
            value={schoolId}
            onChange={(e) => setSchoolId(e.target.value)}
            placeholder="例: 7000"
            autoComplete="off"
            maxLength={50}
          />

          <label className="form-label" style={{ marginTop: '10px' }}>ユーザーID</label>
          <input
            type="text"
            className="form-control"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder=""
            autoComplete="off"
            maxLength={50}
          />

          <label className="form-label" style={{ marginTop: '10px' }}>パスワード</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder=""
            autoComplete="off"
          />
        </FormGroup>

        <Button
          type="submit"
          className="form-submit w-100 mt-3 btn_login-new"
          color="primary"
          disabled={loading || !schoolId || !username || !password}
        >
          ログイン
        </Button>
      </form>
    </GaihanFormContent>
  );

  // Render settings form (Step 2)
  const renderSettingsForm = () => (
    <GaihanFormContent style={{ height: 'auto', marginTop: 0, position: 'relative' }}>
      <p><span style={{ color: '#E37713' }}><b>AI 学トレ</b></span></p>
      <h2 className="mb-3">設定</h2>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px' }}>
        <div className="teacher-info" style={{ flex: 1, marginBottom: 0 }}>
          ログイン中: {teacherDisplayName}
          {teacherInfo?.userId && teacherDisplayName !== teacherInfo.userId
            ? ` (${teacherInfo.userId})`
            : ''}
        </div>
        <Button
          type="button"
          className="btn_logout"
          color="secondary"
          onClick={handleLogout}
        >
          ログアウト
        </Button>
      </div>

      <FormGroup className="form-group">
        <label className="form-label">校舎名</label>
        <SelectSchoolBuilding
          data={optSchoolBuilding}
          schoolBuildingId={schoolBuildingValue}
          setSchoolBuildingId={setSchoolBuildingValue}
          callApi={() => {}}
        />

        <SelectPeriod
          data={periodList}
          periodCode={periodCode}
          setPeriodCode={setPeriodCode}
        />
      </FormGroup>

      <Button
        type="button"
        className="form-submit w-100 mt-3 btn_login-new"
        color="primary"
        disabled={!schoolBuildingValue || !periodCode}
        onClick={handleRegister}
      >
        登録
      </Button>
      <SelectMode />
    </GaihanFormContent>
  );

  return (
    <HomePageLayout
      logout={resetMainMode}
      styleLayout={{ centerScreen: true, flexColumn: !Storage.has('MAIN_MODE') }}
    >
      {Storage.has('MAIN_MODE') ? (
        <IntroPage logout={resetMainMode} setLoading={setLoading} />
      ) : (
        <GaihanWrapper className="signup">
          {step === 1 ? renderLoginForm() : renderSettingsForm()}
        </GaihanWrapper>
      )}
    </HomePageLayout>
  );
};

export default SignInGaihan;
